
import Vue from 'vue'

const locales = {keys(){return []}}
global['____CDCE80F____'] = true;
delete global['____CDCE80F____'];
global.__uniConfig = {"easycom":{"autoscan":true,"custom":{"tui-(.*)":"@/components/tui-$1/tui-$1.vue","^u-(.*)":"uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"久喜医美","navigationBarBackgroundColor":"#FFFFFF","backgroundColor":"#F8F9FA","navigationStyle":"default"},"tabBar":{"color":"#CDCDCD","selectedColor":"#323233","backgroundColor":"#ffffff","height":"50px","fontSize":"10px","iconWidth":"22px","spacing":"2px","borderStyle":"white","list":[{"pagePath":"pages/home/index","iconPath":"static/icon1_1.png","selectedIconPath":"static/icon1_2.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/shop/classfiy/goods","iconPath":"static/icon2_1.png","selectedIconPath":"static/icon2_2.png","text":"分类","redDot":false,"badge":""},{"pagePath":"pages/shop/ShoppingCart/index","iconPath":"static/icon3_1.png","selectedIconPath":"static/icon3_2.png","text":"购物车","redDot":false,"badge":""},{"pagePath":"pages/user/User/index","iconPath":"static/icon4_1.png","selectedIconPath":"static/icon4_2.png","text":"我的","redDot":false,"badge":""}]}};
global.__uniConfig.compilerVersion = '4.24';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__CDCE80F';
global.__uniConfig.appName = '久喜医美';
global.__uniConfig.appVersion = '1.0.1';
global.__uniConfig.appVersionCode = '2';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{}};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-Loading-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/Loading/index"+'.vue')), 'pages-Loading-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-authorization-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/authorization/index"+'.vue')), 'pages-authorization-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-Login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/Login/index"+'.vue')), 'pages-user-Login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-Register-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/Register/index"+'.vue')), 'pages-user-Register-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-about-about', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/about/about"+'.vue')), 'pages-about-about'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-ChangePassword-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/ChangePassword/index"+'.vue')), 'pages-user-ChangePassword-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-brand-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/brand/index"+'.vue')), 'pages-brand-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-integral-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/integral/index"+'.vue')), 'pages-integral-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/home/index"+'.vue')), 'pages-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodSearch-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodSearch/index"+'.vue')), 'pages-shop-GoodSearch-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-StoreList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/StoreList/index"+'.vue')), 'pages-shop-StoreList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-ShoppingCart-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/ShoppingCart/index"+'.vue')), 'pages-shop-ShoppingCart-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodsList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodsList/index"+'.vue')), 'pages-shop-GoodsList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-NotDefined-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/NotDefined/index"+'.vue')), 'pages-NotDefined-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-User-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/User/index"+'.vue')), 'pages-user-User-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodsCollection-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodsCollection/index"+'.vue')), 'pages-shop-GoodsCollection-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodsFoot-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodsFoot/index"+'.vue')), 'pages-shop-GoodsFoot-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-EvaluateList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/EvaluateList/index"+'.vue')), 'pages-shop-EvaluateList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodsEvaluate-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodsEvaluate/index"+'.vue')), 'pages-shop-GoodsEvaluate-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-GoodsCon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/GoodsCon/index"+'.vue')), 'pages-shop-GoodsCon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-collectionCost-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/collectionCost/index"+'.vue')), 'pages-user-collectionCost-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-pointTransfer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/pointTransfer/index"+'.vue')), 'pages-user-pointTransfer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-distributionManagement-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/distributionManagement/index"+'.vue')), 'pages-user-distributionManagement-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-pointRecharge-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/pointRecharge/index"+'.vue')), 'pages-user-pointRecharge-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-myIntegral-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/myIntegral/index"+'.vue')), 'pages-user-myIntegral-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-BindingPhone-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/BindingPhone/index"+'.vue')), 'pages-user-BindingPhone-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-address-AddAddress-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/address/AddAddress/index"+'.vue')), 'pages-user-address-AddAddress-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-address-AddressManagement-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/address/AddressManagement/index"+'.vue')), 'pages-user-address-AddressManagement-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-PersonalData-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/PersonalData/index"+'.vue')), 'pages-user-PersonalData-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-Recharge-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/Recharge/index"+'.vue')), 'pages-user-Recharge-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-MyOrder-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/MyOrder/index"+'.vue')), 'pages-order-MyOrder-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-Logistics-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/Logistics/index"+'.vue')), 'pages-order-Logistics-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-OrderDetails-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/OrderDetails/index"+'.vue')), 'pages-order-OrderDetails-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-OrderReturnDetail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/OrderReturnDetail/index"+'.vue')), 'pages-order-OrderReturnDetail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-OrderSubmission-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/OrderSubmission/index"+'.vue')), 'pages-order-OrderSubmission-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-PaymentStatus-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/PaymentStatus/index"+'.vue')), 'pages-order-PaymentStatus-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-GoodsReturn-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/GoodsReturn/index"+'.vue')), 'pages-order-GoodsReturn-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-ReturnList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/ReturnList/index"+'.vue')), 'pages-order-ReturnList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-submitExpress-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/order/submitExpress/index"+'.vue')), 'pages-order-submitExpress-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-components-goods', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/home/components/goods"+'.vue')), 'pages-home-components-goods'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-deposit-deposit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/deposit/deposit"+'.vue')), 'pages-user-deposit-deposit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-deposit-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/deposit/list"+'.vue')), 'pages-user-deposit-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-deposit-refund', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/deposit/refund"+'.vue')), 'pages-user-deposit-refund'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-Poster-Poster', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/Poster/Poster"+'.vue')), 'pages-user-Poster-Poster'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-team-team', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/team/team"+'.vue')), 'pages-user-team-team'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-team-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/team/list"+'.vue')), 'pages-user-team-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-classfiy-travel', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/classfiy/travel"+'.vue')), 'pages-shop-classfiy-travel'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-classfiy-goods', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/classfiy/goods"+'.vue')), 'pages-shop-classfiy-goods'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/activity/index"+'.vue')), 'pages-activity-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-balance-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/balance/index"+'.vue')), 'pages-user-balance-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-classfiy-customized', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/shop/classfiy/customized"+'.vue')), 'pages-shop-classfiy-customized'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/rank/index"+'.vue')), 'pages-user-rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-cardbag-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/cardbag/index"+'.vue')), 'pages-user-cardbag-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-coupon-GetCoupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/coupon/GetCoupon/index"+'.vue')), 'pages-user-coupon-GetCoupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-coupon-UserCoupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/coupon/UserCoupon/index"+'.vue')), 'pages-user-coupon-UserCoupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-coupon-shareCoupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/coupon/shareCoupon"+'.vue')), 'pages-user-coupon-shareCoupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-coupon-share', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/coupon/share"+'.vue')), 'pages-user-coupon-share'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-coupon-GetCoupon-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/coupon/GetCoupon/detail"+'.vue')), 'pages-user-coupon-GetCoupon-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-performanceDividend-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/pages/user/performanceDividend/index"+'.vue')), 'pages-user-performanceDividend-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-integralCenter-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/integralCenter/index"+'.vue')), 'integralpages-integralCenter-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-integralCenter-questDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/integralCenter/questDetail"+'.vue')), 'integralpages-integralCenter-questDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-integralCenter-receiveSuccessfully', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/integralCenter/receiveSuccessfully"+'.vue')), 'integralpages-integralCenter-receiveSuccessfully'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-shopping-vouchers', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/shopping/vouchers"+'.vue')), 'integralpages-shopping-vouchers'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-shopping-rule', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/shopping/rule"+'.vue')), 'integralpages-shopping-rule'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-submitOrder-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/submitOrder/index"+'.vue')), 'integralpages-submitOrder-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-goods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/goods/index"+'.vue')), 'integralpages-goods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-goods-detalis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/goods/detalis"+'.vue')), 'integralpages-goods-detalis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/order/index"+'.vue')), 'integralpages-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-order-detalis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/order/detalis"+'.vue')), 'integralpages-order-detalis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-afterSale-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/afterSale/index"+'.vue')), 'integralpages-afterSale-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('integralpages-afterSale-applyRefund', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/工作/project/gitlab/玖禧医美单商户/askj-jxym-uniapp/integralpages/afterSale/applyRefund"+'.vue')), 'integralpages-afterSale-applyRefund'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/Loading/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"久喜医美","navigationStyle":"custom"})
      },
      [
        createElement('pages-Loading-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-Loading-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Loading/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/authorization/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"微信授权"})
      },
      [
        createElement('pages-authorization-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-authorization-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/authorization/index',
  windowTop:44
}
},
{
path: '/pages/user/Login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-user-Login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-Login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/Login/index',
  windowTop:44
}
},
{
path: '/pages/user/Register/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册"})
      },
      [
        createElement('pages-user-Register-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-Register-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/Register/index',
  windowTop:44
}
},
{
path: '/pages/about/about',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"平台介绍","enablePullDownRefresh":false})
      },
      [
        createElement('pages-about-about', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-about-about',
  isNVue:false,maxWidth:0,
  pagePath:'pages/about/about',
  windowTop:44
}
},
{
path: '/pages/user/ChangePassword/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"重置密码"})
      },
      [
        createElement('pages-user-ChangePassword-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-ChangePassword-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/ChangePassword/index',
  windowTop:44
}
},
{
path: '/pages/brand/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品牌故事","enablePullDownRefresh":false})
      },
      [
        createElement('pages-brand-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-brand-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/brand/index',
  windowTop:44
}
},
{
path: '/pages/integral/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分商城","enablePullDownRefresh":false})
      },
      [
        createElement('pages-integral-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-integral-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/integral/index',
  windowTop:44
}
},
{
path: '/pages/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"久喜医美","enablePullDownRefresh":false,"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-home-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/index',
isQuit:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/shop/GoodSearch/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索商品"})
      },
      [
        createElement('pages-shop-GoodSearch-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodSearch-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodSearch/index',
  windowTop:44
}
},
{
path: '/pages/shop/StoreList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"门店列表"})
      },
      [
        createElement('pages-shop-StoreList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-StoreList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/StoreList/index',
  windowTop:44
}
},
{
path: '/pages/shop/ShoppingCart/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-shop-ShoppingCart-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-shop-ShoppingCart-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/ShoppingCart/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/shop/GoodsList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品搜索"})
      },
      [
        createElement('pages-shop-GoodsList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodsList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodsList/index',
  windowTop:44
}
},
{
path: '/pages/NotDefined/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"404"})
      },
      [
        createElement('pages-NotDefined-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-NotDefined-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/NotDefined/index',
  windowTop:44
}
},
{
path: '/pages/user/User/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的","navigationStyle":"custom"})
      },
      [
        createElement('pages-user-User-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-user-User-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/User/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/shop/GoodsCollection/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品收藏"})
      },
      [
        createElement('pages-shop-GoodsCollection-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodsCollection-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodsCollection/index',
  windowTop:44
}
},
{
path: '/pages/shop/GoodsFoot/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的足迹"})
      },
      [
        createElement('pages-shop-GoodsFoot-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodsFoot-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodsFoot/index',
  windowTop:44
}
},
{
path: '/pages/shop/EvaluateList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"评价列表"})
      },
      [
        createElement('pages-shop-EvaluateList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-EvaluateList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/EvaluateList/index',
  windowTop:44
}
},
{
path: '/pages/shop/GoodsEvaluate/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('pages-shop-GoodsEvaluate-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodsEvaluate-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodsEvaluate/index',
  windowTop:44
}
},
{
path: '/pages/shop/GoodsCon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-shop-GoodsCon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-GoodsCon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/GoodsCon/index',
  windowTop:44
}
},
{
path: '/pages/user/collectionCost/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取转赠"})
      },
      [
        createElement('pages-user-collectionCost-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-collectionCost-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/collectionCost/index',
  windowTop:44
}
},
{
path: '/pages/user/pointTransfer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分转让"})
      },
      [
        createElement('pages-user-pointTransfer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-pointTransfer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/pointTransfer/index',
  windowTop:44
}
},
{
path: '/pages/user/distributionManagement/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销管理"})
      },
      [
        createElement('pages-user-distributionManagement-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-distributionManagement-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/distributionManagement/index',
  windowTop:44
}
},
{
path: '/pages/user/pointRecharge/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分充值"})
      },
      [
        createElement('pages-user-pointRecharge-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-pointRecharge-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/pointRecharge/index',
  windowTop:44
}
},
{
path: '/pages/user/myIntegral/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的积分"})
      },
      [
        createElement('pages-user-myIntegral-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-myIntegral-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/myIntegral/index',
  windowTop:44
}
},
{
path: '/pages/user/BindingPhone/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机号"})
      },
      [
        createElement('pages-user-BindingPhone-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-BindingPhone-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/BindingPhone/index',
  windowTop:44
}
},
{
path: '/pages/user/address/AddAddress/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增收货地址"})
      },
      [
        createElement('pages-user-address-AddAddress-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-address-AddAddress-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/address/AddAddress/index',
  windowTop:44
}
},
{
path: '/pages/user/address/AddressManagement/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址"})
      },
      [
        createElement('pages-user-address-AddressManagement-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-address-AddressManagement-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/address/AddressManagement/index',
  windowTop:44
}
},
{
path: '/pages/user/PersonalData/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人资料"})
      },
      [
        createElement('pages-user-PersonalData-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-PersonalData-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/PersonalData/index',
  windowTop:44
}
},
{
path: '/pages/user/Recharge/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"充值"})
      },
      [
        createElement('pages-user-Recharge-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-Recharge-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/Recharge/index',
  windowTop:44
}
},
{
path: '/pages/order/MyOrder/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单"})
      },
      [
        createElement('pages-order-MyOrder-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-MyOrder-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/MyOrder/index',
  windowTop:44
}
},
{
path: '/pages/order/Logistics/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"查看物流"})
      },
      [
        createElement('pages-order-Logistics-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-Logistics-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/Logistics/index',
  windowTop:44
}
},
{
path: '/pages/order/OrderDetails/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-order-OrderDetails-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-OrderDetails-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/OrderDetails/index',
  windowTop:44
}
},
{
path: '/pages/order/OrderReturnDetail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后详情"})
      },
      [
        createElement('pages-order-OrderReturnDetail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-OrderReturnDetail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/OrderReturnDetail/index',
  windowTop:44
}
},
{
path: '/pages/order/OrderSubmission/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-order-OrderSubmission-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-OrderSubmission-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/OrderSubmission/index',
  windowTop:44
}
},
{
path: '/pages/order/PaymentStatus/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付状态"})
      },
      [
        createElement('pages-order-PaymentStatus-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-PaymentStatus-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/PaymentStatus/index',
  windowTop:44
}
},
{
path: '/pages/order/GoodsReturn/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品退货"})
      },
      [
        createElement('pages-order-GoodsReturn-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-GoodsReturn-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/GoodsReturn/index',
  windowTop:44
}
},
{
path: '/pages/order/ReturnList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的售后"})
      },
      [
        createElement('pages-order-ReturnList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-ReturnList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/ReturnList/index',
  windowTop:44
}
},
{
path: '/pages/order/submitExpress/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后物流填写"})
      },
      [
        createElement('pages-order-submitExpress-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-submitExpress-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/submitExpress/index',
  windowTop:44
}
},
{
path: '/pages/home/components/goods',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分类","enablePullDownRefresh":false})
      },
      [
        createElement('pages-home-components-goods', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-components-goods',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/components/goods',
  windowTop:44
}
},
{
path: '/pages/user/deposit/deposit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-deposit-deposit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-deposit-deposit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/deposit/deposit',
  windowTop:44
}
},
{
path: '/pages/user/deposit/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金明细","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-deposit-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-deposit-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/deposit/list',
  windowTop:44
}
},
{
path: '/pages/user/deposit/refund',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金提现","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-deposit-refund', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-deposit-refund',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/deposit/refund',
  windowTop:44
}
},
{
path: '/pages/user/Poster/Poster',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的二维码","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-Poster-Poster', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-Poster-Poster',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/Poster/Poster',
  windowTop:44
}
},
{
path: '/pages/user/team/team',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的团队","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-team-team', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-team-team',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/team/team',
  windowTop:44
}
},
{
path: '/pages/user/team/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收益明细","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-team-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-team-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/team/list',
  windowTop:44
}
},
{
path: '/pages/shop/classfiy/travel',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"旅游专区","enablePullDownRefresh":false})
      },
      [
        createElement('pages-shop-classfiy-travel', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-classfiy-travel',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/classfiy/travel',
  windowTop:44
}
},
{
path: '/pages/shop/classfiy/goods',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品分类","enablePullDownRefresh":false})
      },
      [
        createElement('pages-shop-classfiy-goods', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-shop-classfiy-goods',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/classfiy/goods',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/activity/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"最新活动","enablePullDownRefresh":false})
      },
      [
        createElement('pages-activity-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/index',
  windowTop:44
}
},
{
path: '/pages/user/balance/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"钱包余额","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-balance-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-balance-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/balance/index',
  windowTop:44
}
},
{
path: '/pages/shop/classfiy/customized',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"私人订制","enablePullDownRefresh":false})
      },
      [
        createElement('pages-shop-classfiy-customized', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-shop-classfiy-customized',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/classfiy/customized',
  windowTop:44
}
},
{
path: '/pages/user/rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的等级","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/rank/index',
  windowTop:44
}
},
{
path: '/pages/user/cardbag/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的卡包","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-cardbag-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-cardbag-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/cardbag/index',
  windowTop:44
}
},
{
path: '/pages/user/coupon/GetCoupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"优惠券列表"})
      },
      [
        createElement('pages-user-coupon-GetCoupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-coupon-GetCoupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/coupon/GetCoupon/index',
  windowTop:44
}
},
{
path: '/pages/user/coupon/UserCoupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('pages-user-coupon-UserCoupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-coupon-UserCoupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/coupon/UserCoupon/index',
  windowTop:44
}
},
{
path: '/pages/user/coupon/shareCoupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分享优惠券","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-coupon-shareCoupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-coupon-shareCoupon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/coupon/shareCoupon',
  windowTop:44
}
},
{
path: '/pages/user/coupon/share',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分享","enablePullDownRefresh":false})
      },
      [
        createElement('pages-user-coupon-share', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-coupon-share',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/coupon/share',
  windowTop:44
}
},
{
path: '/pages/user/coupon/GetCoupon/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取优惠券"})
      },
      [
        createElement('pages-user-coupon-GetCoupon-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-coupon-GetCoupon-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/coupon/GetCoupon/detail',
  windowTop:44
}
},
{
path: '/pages/user/performanceDividend/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"业绩分红","navigationStyle":"custom"})
      },
      [
        createElement('pages-user-performanceDividend-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-performanceDividend-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/performanceDividend/index',
  windowTop:0
}
},
{
path: '/integralpages/integralCenter/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-integralCenter-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-integralCenter-index',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/integralCenter/index',
  windowTop:0
}
},
{
path: '/integralpages/integralCenter/questDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"任务详情"})
      },
      [
        createElement('integralpages-integralCenter-questDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-integralCenter-questDetail',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/integralCenter/questDetail',
  windowTop:44
}
},
{
path: '/integralpages/integralCenter/receiveSuccessfully',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取成功"})
      },
      [
        createElement('integralpages-integralCenter-receiveSuccessfully', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-integralCenter-receiveSuccessfully',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/integralCenter/receiveSuccessfully',
  windowTop:44
}
},
{
path: '/integralpages/shopping/vouchers',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分记录","enablePullDownRefresh":true})
      },
      [
        createElement('integralpages-shopping-vouchers', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-shopping-vouchers',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/shopping/vouchers',
  windowTop:44
}
},
{
path: '/integralpages/shopping/rule',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分规则","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-shopping-rule', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-shopping-rule',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/shopping/rule',
  windowTop:44
}
},
{
path: '/integralpages/submitOrder/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-submitOrder-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-submitOrder-index',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/submitOrder/index',
  windowTop:44
}
},
{
path: '/integralpages/goods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部商品","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-goods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-goods-index',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/goods/index',
  windowTop:44
}
},
{
path: '/integralpages/goods/detalis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-goods-detalis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-goods-detalis',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/goods/detalis',
  windowTop:44
}
},
{
path: '/integralpages/order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分订单","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/order/index',
  windowTop:44
}
},
{
path: '/integralpages/order/detalis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","enablePullDownRefresh":false})
      },
      [
        createElement('integralpages-order-detalis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-order-detalis',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/order/detalis',
  windowTop:44
}
},
{
path: '/integralpages/afterSale/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"售后"})
      },
      [
        createElement('integralpages-afterSale-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-afterSale-index',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/afterSale/index',
  windowTop:44
}
},
{
path: '/integralpages/afterSale/applyRefund',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退款"})
      },
      [
        createElement('integralpages-afterSale-applyRefund', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'integralpages-afterSale-applyRefund',
  isNVue:false,maxWidth:0,
  pagePath:'integralpages/afterSale/applyRefund',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
